import moment from 'moment'
export const packages = {
    state: {
        pricelists: {},
        mutabletPricelist: {},
        currentYear: moment().format('YYYY'),
        currentMonth: moment().format('MM'),
        packages: [
            {
                warehouseId: null,
                externalSupplier: null,
                packages: []
            }
        ],
        featuredPackages: [
            {
                warehouseId: null,
                externalSupplier: null,
                packages: []
            }
        ]
    },
    mutations: {
        SET_PRICELISTS(state, pricelists) {
            state.pricelists = pricelists
        },
        SET_MUTABLE_PRICELISTS(state, mutabletPricelist) {
            state.mutabletPricelist = mutabletPricelist
        },
        SET_PACKAGES(state, payload) {
            state.packages.push(payload)
        },
        SET_FEATURED_PACKAGES(state, payload) {
            state.featuredPackages.push(payload)
        }
    },
    actions: {
        fetchPackages({ commit, getters }, payload) {
            if(typeof payload.warehouseId === 'number' &&
            getters.packages(payload.warehouseId, payload.externalSupplier) === null) {
                return new Promise((resolve, reject) => {
                    this.$api.get(`b2b/v2/packages/list/${payload.warehouseId}/0/${payload.externalSupplier}`).then(response => {
                        commit('SET_PACKAGES', {
                            warehouseId: payload.warehouseId,
                            externalSupplier: payload.externalSupplier,
                            packages: response.data.data
                        })
                        resolve()
                    })
                })
            } else {
                return false
            }
        },
        fetchFeaturedPackages({ commit, getters }, payload) {
            const companySize = +payload.companySize
            if(typeof payload.warehouseId === 'number' && typeof companySize === 'number' &&
            getters.featuredPackages(payload.warehouseId, payload.externalSupplier) === null) {
                return new Promise((resolve, reject) => {
                    this.$api.get(`b2b/v2/suggestions/list/${payload.warehouseId}/${companySize}/0/${payload.externalSupplier}`).then(response => {
                        commit('SET_FEATURED_PACKAGES', {
                            warehouseId: payload.warehouseId,
                            externalSupplier: payload.externalSupplier,
                            packages: response.data.data
                        })
                        resolve()
                    })
                })
            }
        },
        fetchPricelists({ commit, getters, state }) {
            if(Object.keys(state.pricelists).length === 0) {
                return new Promise((resolve, reject) => {
                    this.$api.get(`b2b/v2/management/pricelists?year=${state.currentYear}`).then(response => {
                        commit('SET_PRICELISTS', response.data.data)
                        resolve()
                    })
                })
            }
        },
        fetchMutablePricelists({ commit, getters, state }) {
            if(Object.keys(state.mutabletPricelist).length === 0) {
                return new Promise((resolve, reject) => {
                    this.$api.get(`b2b/v1/management/mutable_pricelists?year=${state.currentYear}`).then(response => {
                        commit('SET_MUTABLE_PRICELISTS', response.data.data)
                        resolve()
                    })
                })
            }
        }
    },
    getters: {
        // addressId greater than 0 is given when addressId is related to customer modules
        // addressId less than 0 is given when addressId is related to companies modules
        packagesByAddressId: (state, getters) => addressId => {
            let warehouseId
            let externalSupplier
            if(addressId >= 0) {
                // customer modules
                warehouseId = getters.customerAddressWarehouseId(addressId)
                externalSupplier = getters.customerAddressExternalSupplier(addressId)
            } else {
                // companies modules
                addressId = Math.abs(addressId)
                const address = getters['companies/addresses'].find(
                    address => address.id === addressId
                )
                if(address) {
                    warehouseId = address.warehouse_id
                    externalSupplier = address.external_supplier ? 1 : 0
                    addressId = 0
                }
            }
            const idx = state.packages.findIndex(item => item.warehouseId === warehouseId && item.externalSupplier === externalSupplier)
            return idx !== -1 ? state.packages[idx].packages : null
        },
        packages: state => (warehouseId, externalSupplier) => {
            const supplier = externalSupplier ? 1 : 0
            const idx = state.packages.findIndex(item => item.warehouseId === warehouseId && item.externalSupplier === supplier)
            return idx !== -1 ? state.packages[idx].packages : null
        },
        featuredPackages: (state, getters) => (warehouseId, externalSupplier) => {
            const supplier = externalSupplier ? 1 : 0
            const idx = state.featuredPackages.findIndex(item => item.warehouseId === warehouseId && item.externalSupplier === supplier)
            return idx !== -1 ? state.featuredPackages[idx].packages : null
        },
        packagesPackagesWithPrice: (state, getters) => (addressId, isOneTimeOrder = false) => {
            const packages = getters.packagesByAddressId(addressId)
            if(packages !== null && Object.keys(packages).length > 0 && (isOneTimeOrder ? state.mutabletPricelist : state.pricelists)) {
                return packages.map(item => getters.packagesSinglePackage(item.id, addressId))
            }
        },
        packagePrice: (state, getters) => (id, dayInWeek, addressId, isOneTimeOrder = false) => {
            const packages = getters.packagesByAddressId(addressId)
            const round = (value) => {
                return Math.round(value * 100) / 100
            }
            if(packages !== null && Object.keys(packages).length > 0 && (isOneTimeOrder ? state.mutabletPricelist : state.pricelists)) {
                const pack = packages.find(item => item.id === id)
                let price = 0
                let bonus = 0
                let discount = 0
                if(pack !== undefined) {
                    pack.products.forEach((item, idx) => {
                        let singlePrice = null
                        if (isOneTimeOrder) {
                            singlePrice = state.mutabletPricelist[`${state.currentYear}-${state.currentMonth}`][item.id]
                        } else {
                            singlePrice = state.pricelists[state.currentYear][item.id]
                        }
                        price += singlePrice * item.amount
                        const discountCategory = getters.discountCategories[item.id] || null
                        if(discountCategory) {
                            // calc discount
                            discount = getters.getDiscount(discountCategory, dayInWeek, addressId) || 0
                            bonus += round(item.amount * round((singlePrice * discount / 100)))
                        }
                    })
                    // calc package bonus
                    bonus = bonus / price
                    bonus = Math.round(bonus * 10000) / 10000
                    // calc package
                    let packPrice = 0

                    pack.products.forEach((item, idx) => {
                        if (isOneTimeOrder) {
                            item.price = round(item.amount * round(state.mutabletPricelist[`${state.currentYear}-${state.currentMonth}`][item.id] * (1 - bonus)))
                        } else {
                            item.price = round(item.amount * round(state.pricelists[state.currentYear][item.id] * (1 - bonus)))
                        }

                        packPrice += item.price
                    })
                    packPrice = round(packPrice)
                    return packPrice
                }
            }
        },
        packagePriceWithoutDiscount: (state, getters) => (id, addressId, isOneTimeOrder = false) => {
            const packages = getters.packagesByAddressId(addressId)
            if(packages !== null && Object.keys(packages).length > 0 && (isOneTimeOrder ? state.mutabletPricelist : state.pricelists)) {
                const pack = packages.find(item => item.id === id)
                if(pack) {
                    let packPrice = 0
                    pack.products.forEach((item, idx) => {
                        if (isOneTimeOrder) {
                            item.price = +(state.mutabletPricelist[`${state.currentYear}-${state.currentMonth}`][item.id] * item.amount).toFixed(2)
                        } else {
                            item.price = +(state.pricelists[state.currentYear][item.id] * item.amount).toFixed(2)
                        }
                        packPrice += item.price
                    })
                    packPrice = +packPrice.toFixed(2)
                    return packPrice
                }
            }
        },
        packagePriceDiscount: (state, getters) => (id, dayInWeek, addressId, isOneTimeOrder = false) => {
            const packages = getters.packagesByAddressId(addressId)
            if(packages !== null && Object.keys(packages).length > 0 && (isOneTimeOrder ? state.mutabletPricelist : state.pricelists)) {
                const pack = packages.find(item => item.id === id)
                if(pack) {
                    let price = 0
                    let bonus = 0
                    let discount = 0
                    pack.products.forEach((item, idx) => {
                        let singlePrice = ''
                        if (isOneTimeOrder) {
                            singlePrice = state.mutabletPricelist[`${state.currentYear}-${state.currentMonth}`][item.id]
                        } else {
                            singlePrice = state.pricelists[state.currentYear][item.id]
                        }
                        price += singlePrice
                        const discountCategory = getters.discountCategories[item.id] || null
                        if(discountCategory) {
                            // calc discount
                            discount = getters.getDiscount(discountCategory, dayInWeek, addressId) || 0
                            bonus += singlePrice * discount / 100
                        }
                    })
                    // calc package bonus
                    bonus = bonus / price
                    bonus = +bonus.toFixed(4)
                    // calc package
                    let packPrice = 0

                    pack.products.forEach((item, idx) => {
                        if (isOneTimeOrder) {
                            item.price = +(state.mutabletPricelist[`${state.currentYear}-${state.currentMonth}`][item.id] * bonus * item.amount).toFixed(2)
                        } else {
                            item.price = +(state.pricelists[state.currentYear][item.id] * bonus * item.amount).toFixed(2)
                        }
                        packPrice += item.price
                    })
                    packPrice = +packPrice.toFixed(2)
                    return packPrice
                }
            }
        },
        packagesSinglePackage: (state, getters) => (id, addressId, isOneTimeOrder = false) => {
            const packages = getters.packagesByAddressId(addressId)
            if(packages !== null && Object.keys(packages).length > 0 && (isOneTimeOrder ? state.mutabletPricelist : state.pricelists)) {
                const pack = packages.find(item => item.id === id)
                const products = []
                pack.products.forEach((item, idx) => {
                    products[idx] = item
                })

                pack.products = products
                return pack
            }
        },
        packageById: (state, getters) => (id, addressId) => {
            const packages = getters.packagesByAddressId(addressId)
            if(packages) {
                return packages.find(item => id === item.id)
            }
        }
    }
}
